import { render, staticRenderFns } from "./ChooseCcsqdList.vue?vue&type=template&id=244d99b2&scoped=true&"
import script from "./ChooseCcsqdList.vue?vue&type=script&lang=js&"
export * from "./ChooseCcsqdList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244d99b2",
  null
  
)

export default component.exports